import { render } from "./Bookmark.vue?vue&type=template&id=5f749db4&scoped=true"
import script from "./Bookmark.vue?vue&type=script&lang=js"
export * from "./Bookmark.vue?vue&type=script&lang=js"

import "./Bookmark.vue?vue&type=style&index=0&id=5f749db4&scoped=true&lang=css"
import "./Bookmark.vue?vue&type=style&index=1&id=5f749db4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f749db4"],['__file',"src/views/pharmarcy/Bookmark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f749db4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f749db4', __exports__)) {
    api.reload('5f749db4', __exports__)
  }
  
  module.hot.accept("./Bookmark.vue?vue&type=template&id=5f749db4&scoped=true", () => {
    api.rerender('5f749db4', render)
  })

}


export default __exports__